<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body">
        <div class="form" v-if="inbound">
          <div class="row form-group">
            <label class="col-6 col-md-4 col-lg-3">Inbound Data</label>
            <div class="col-6 col-md-8 col-lg-9">
              <span class="font-weight-bold text-uppercase">{{inbound.product.name}} / {{inbound.document_number}} / {{inbound.supplier.name}} / {{inbound.quantity}} {{ inbound.product.unit }}</span>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-6 col-md-4 col-lg-3">Barcode Type</label>
            <div class="col-6 col-md-8 col-lg-9">
              <kendo-switch :on-label="'UNIVERSAL'" :off-label="'SEPARATE'" :checked="universalBarcode" @change="typeChange" v-bind:disabled="submitted"></kendo-switch>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-6 col-md-4 col-lg-3">Item Count</label>
            <div class="col-6 col-md-8 col-lg-9">
              <input type="number" min="1" class="form-control" max="1000" placeholder="Item Count" v-model="total" v-bind:disabled="submitted" @change="initInboundItemForm">
              <small v-bind:class=" { 'd-none': verification.count } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Arrival Date</label>
            <div class="col-6 col-md-8 col-lg-9">
              <kendo-datepicker v-model="arrivalDate" class="form-control" v-bind:disabled="submitted"></kendo-datepicker>
              <small v-bind:class=" { 'd-none': verification.date } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-6 col-md-4 col-lg-3">Item Conditions</label>
            <div class="col-6 col-md-8 col-lg-9">
              <kendo-dropdownlist class="form-control"
                :option-label="'Select Items Condition'"
                :data-source="statuses"
                :data-text-field="'name'"
                :data-value-field="'id'"
                v-model="status"
                v-bind:disabled="submitted"></kendo-dropdownlist>
              <small v-bind:class=" { 'd-none': verification.status } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="row form-group" v-for="(item, index) in items" :key="index" v-if="index === 0 || !universalBarcode">
            <label class="col-6 col-md-4 col-lg-3">Item <span v-bind:class="{'d-none': universalBarcode}">{{index + 1}}</span> Code</label>
            <div class="col-6 col-md-8 col-lg-9">
              <div class="row">
                <div class="col-11">
                  <input type="text" placeholder="Item Code" class="form-control" @change="submitItem($event, index)"
                    v-bind:disabled="!verifyForm() || item.uid" v-model="item.tempCode"/>
                </div>
                <div class="col-1 text-right">
                  <button class="btn btn-outline-success" v-bind:class="{ 'd-none': !item.uid }"
                      style="width: 35px !important; border-radius: 20px;" @click="editItem($event, index)">
                    <i class="fa fa-edit" style="margin-left: -3px; margin-top: 1px"></i>
                  </button>
                  <button class="btn btn-outline-secondary" v-bind:class="{ 'd-none': !item.tempUid }"
                      style="width: 35px !important; border-radius: 20px;" @click="cancelEditItem($event, index)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-0 text-right">
      <button class="btn btn-outline-primary d-none d-md-inline-block" @click="addMore()"
        v-bind:disabled="!submitted"><i class="fa fa-plus"></i>&nbsp;&nbsp;ADD MORE ITEMS</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      submitted: false,
      inbound: null,
      total: 50,
      arrivalDate: moment().format('DD-MM-YYYY'),
      universalBarcode: false,
      status: null,
      items: [],
      verification: {
        date: true,
        count: true,
        status: true
      },
      statuses: [
        {
          id: 'baik',
          name: 'OKAY'
        },
        {
          id: 'agak rusak',
          name: 'MINOR DAMAGE'
        },
        {
          id: 'rusak',
          name: 'DAMAGED'
        },
        {
          id: 'sangat rusak',
          name: 'MAJORLY DAMAGED'
        }
      ]
    }
  },
  created () {
    this.getInbound()
  },
  methods: {
    getInbound () {
      var uid = this.$route.params.uid
      var vm = this
      vm.axios.get('api/inventory/inbound/' + uid)
        .then(
          (response) => {
            vm.inbound = response.data
            console.log(vm.inbound)
            vm.initInboundItemForm()
          }
        )
        .catch(
          (error) => {
            console.log(error.response)
            vm.$router.push('Four Oh Four')
          }
        )
    },
    initInboundItemForm () {
      if (this.items.length > this.total) {
        // remove last item
        for (var i = this.items.length; i >= this.total; i--) {
          this.items.splice(i, 1)
        }
      } else if (this.items.length < this.total) {
        for (var ii = this.items.length; ii < this.total; ii++) {
          var item = {
            uid: null,
            tempUid: null,
            arrival: null,
            condition: null,
            tempCode: null,
            code: null
          }
          this.items.push(item)
        }
      }
    },
    typeChange (event) {
      this.universalBarcode = event.sender.value()
    },
    submitItem (event, index) {
      // do submit item
      var value = event.target.value
      if (value.length === 0) {
        if (this.items[index].tempUid) {
          this.items[index].uid = this.items[index].tempUid
          this.items[index].tempUid = null
          this.items[index].tempCode = this.items[index].code
        }
      } else {
        if (value.length > 0) {
          if (this.verifyForm()) {
            // gather from data)
            var item = this.items[index]
            item.arrival = this.arrivalDate
            item.condition = this.status
            item.code = value
            // convert to url search params
            var formData = new URLSearchParams()
            formData.append('inbound', this.inbound.uid)
            formData.append('code', item.code.toUpperCase())
            formData.append('condition', item.condition)
            formData.append('arrival_date', moment(item.arrival, 'DD-MM-YYYY').format('YYYY-MM-DD'))
            // do actual submit here
            if (!this.items[index].tempUid) {
              if (!this.universalBarcode) {
                this.submit(index, formData)
              } else {
                for (var i = 0; i < this.items.length; i++) {
                  this.submit(i, formData)
                }
              }
            } else {
              if (!this.universalBarcode) {
                this.update(this.items[index].tempUid, index, formData)
              } else {
                for (var ii = 0; ii < this.items.length; ii++) {
                  this.update(this.items[ii].tempUid, ii, formData)
                }
              }
            }
          }
        }
      }
    },
    editItem (event, index) {
      if (!this.universalBarcode) {
        this.items[index].tempUid = this.items[index].uid
        this.items[index].uid = null
      } else {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].tempUid = this.items[i].uid
          this.items[i].uid = null
        }
      }
    },
    cancelEditItem (event, index) {
      if (!this.universalBarcode) {
        this.items[index].uid = this.items[index].tempUid
        this.items[index].tempUid = null
      } else {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].uid = this.items[i].tempUid
          this.items[i].tempUid = null
        }
      }
    },
    verifyForm () {
      if (!this.total || (this.total && parseInt(this.total, 10) === 0)) {
        this.verification.count = false
        return false
      } else {
        this.verification.count = true
      }
      if (!this.arrivalDate || (this.arrivalDate && this.arrivalDate.length === 0)) {
        this.verification.date = false
        return false
      } else {
        this.verification.date = true
      }
      if (!this.status || (this.status && this.status.length === 0)) {
        this.verification.status = false
        return false
      } else {
        this.verification.status = true
      }
      return true
    },
    submit (index, formData) {
      console.log(formData.toString())
      var vm = this
      vm.axios.post('api/inventory/inbound/item/', formData)
        .then(
          response => {
            console.log(response)
            var data = response.data
            vm.items[index].uid = data.uid
            vm.inbound.quantity += 1
            vm.submitted = true
          }
        )
        .catch(
          error => {
            console.log(error)
          }
        )
    },
    update (uid, index, formData) {
      console.log(formData.toString())
      var vm = this
      vm.axios.put('api/inventory/inbound/item/' + uid + '/', formData)
        .then(
          response => {
            console.log(response)
            var data = response.data
            vm.items[index].uid = data.uid
            vm.items[index].tempUid = null
          }
        )
        .catch(
          error => {
            console.log(error)
          }
        )
    },
    addMore () {
      window.location.reload()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/inbound/AddInboundItem.vue